import LogRocket from "logrocket";
import { Authenticator } from "./libs/authentication/authenticator";
import OpenIdSettings, {
  OidcEndpoints,
} from "./libs/authentication/openIdSettings";
import { bootstrap } from "./libs/startup/bootstrap";
import { logError, logInfo } from "./logger";
import { AppSettings } from "./libs/configuration/appsettings";
import "./styles";

LogRocket.init(AppSettings.LOG_ROCKET_APP_NAME);

const authenticator = Authenticator.getInstance(OpenIdSettings);

const path = window.location.pathname.substring(1);

switch (path) {
  case OidcEndpoints.LOGIN:
    authenticator.handleLoginCallbackAsync().then(() => {
      bootstrap(authenticator, AppSettings).then();
    });

    break;
  case OidcEndpoints.RENEW:
    authenticator
      .handleSilentRenewCallbackAsync()
      .then(() => {
        logInfo("Token renewal has processed");
      })
      .catch(logError);

    break;
  case OidcEndpoints.SWITCH_ACCOUNTS:
    authenticator
      .getUserManager()
      .removeUser()
      .then(() =>
        authenticator
          .getUserManager()
          .revokeAccessToken()
          .then(() => {
            const urlParams = new URLSearchParams(window.location.search);
            const app = urlParams.get("app");
            window.location.href = `https://${window.location.host}${app}`;
          })
      );
    break;
  default:
    bootstrap(authenticator, AppSettings).then();

    break;
}
